if (window.matchMedia("(max-width: 1024px)").matches) {
 			 /* The viewport is less than, or equal to, 700 pixels wide */
              $('.multi-filter').click(function(){
               if($(this).hasClass('checked')){

              
                 $(this).removeClass("checked");

                }
                else
                {  
                
                  $(this).parents(".radio-group").find('.multi-filter').removeClass("checked");
				$(this).addClass("checked");
                    $(this).attr("checked", "checked");
                }
            });

            $('.filter-done').click(function(){

               var newVals = [];
                $('.multi-filter').each(function() {
                  if($(this).hasClass('checked')){
                  var value = $(this).attr('value');
                    newVals.push(value);

                  }
                });


               var tag_handle = $('#collection-handle').attr('handle');
               var newURL = '/collections/' + tag_handle+ '/' ;
                    if(newVals.length){
                      newURL = newURL+ newVals.join('+');
                    }
              location.href = newURL;
            });
    } 
    else
    {
			  /* The viewport is greater than 700 pixels wide */
  			$('.multi-filter').click(function(){
  
                 var newVals = [];

                if($(this).hasClass('checked')){

               
                  $(this).removeClass("checked");

                }
                else
                {  
                 
                   $(this).parents(".radio-group").find('.multi-filter').removeClass("checked");
                  $(this).addClass("checked");
                   
                }


                $('.multi-filter').each(function() {
                  if($(this).hasClass('checked')){
                  var value = $(this).attr('value');
                    newVals.push(value);

                  }
                });


               var tag_handle = $('#collection-handle').attr('handle');
               var newURL = '/collections/' + tag_handle+ '/' ;
                    if(newVals.length){
                      newURL = newURL+ newVals.join('+');
                    }
              location.href = newURL;
              }); 

	}                   


 $('.reset-filter').click(function(){
    var tag_handle = $('#collection-handle').attr('handle');
   var newURL = '/collections/' + tag_handle+ '/' ;
  location.href = newURL;
   });
  

